<script>
  import { Accordion } from "bits-ui";
  import IconChevron from "$lib/components/Icons/IconChevron.svelte";
  let { id, label, children } = $props();
</script>

<div>
  <Accordion.Item
    value={id}
    class="accordion-item"
  >
    <Accordion.Header>
      <Accordion.Trigger class="accordion-trigger">
        <p class="control-label">{label}</p>
        <span class="accordion-icon"><IconChevron size={16} /> </span></Accordion.Trigger
      >
    </Accordion.Header>
    <Accordion.Content>
      {@render children?.()}
    </Accordion.Content>
  </Accordion.Item>
</div>

<style>
  div :global(.accordion-item) {
    border-bottom: solid 1px var(--color-gray-shade-lighter);
  }
  div :global(.accordion-item[data-state="open"]) {
    padding-bottom: var(--spacing-5);
  }
  div :global(.accordion-trigger) {
    background: transparent;
    font-family: inherit;
    appearance: none;
    border: none;
    display: flex;
    width: 100%;
    cursor: pointer;
    align-items: center;
    justify-content: space-between;
    padding: 0;
  }
  div :global(.accordion-trigger:focus-visible) {
    outline: 2px solid var(--color-blue-shade-darker);
  }

  .control-label {
    margin-block: var(--spacing-2);
    font-size: 16px !important;
    font-weight: var(--font-weight-bold) !important;
    font-family: var(--font-family-sans-alt) !important;
  }

  :global([data-state="open"]) .accordion-icon {
    rotate: 180deg;
  }
</style>
